import { createReducer, on } from '@ngrx/store'
import { initialAuthState } from '../state/auth.state'
import { login_failed, login_success } from '../action/auth.action'
import { AuthService } from 'src/app/services/auth/auth.service'

export function authReducer(state, action) {
  return _authReducer(state, action)
}

const _authReducer = createReducer(
  initialAuthState,
  on(login_success, (state, action) => {
    AuthService.setToken(action.bearer_token)
    return {
      ...state,
      userAuthenticated: true,
      bearerToken: action.bearer_token
    }
  }),
  on(login_failed, (state) => {
    return {
      ...state,
      userAuthenticated: false,
      bearerToken: null
    }
  })
)
